import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileSaver from 'file-saver';
import React from 'react';
import { useDispatch } from 'react-redux';

import { fetchSiteListingForCustomer } from '@sophocles/entities/Customer';
import ReportLinkItem from '@sophocles/views/reports/components/ReportLinkItem';

function CustomerSiteListingContainer({ isBillboard, customerId, customerName }) {
  const dispatch = useDispatch();

  const fetchData = () => {
    const filename = `${customerName ?? 'sites'}_sites.xlsx`;

    dispatch(fetchSiteListingForCustomer(customerId)).then(blob => FileSaver.saveAs(new Blob([blob]), filename));
  };

  return (
    <ReportLinkItem
      onClick={fetchData}
      icon={<FileDownloadOutlinedIcon />}
      primary={`Download ${isBillboard ? 'Structure' : 'Site'} Listing`}
      secondary="Export the full list as an Excel spreadsheet"
    />
  );
}

export default CustomerSiteListingContainer;
